export default Object.freeze({
  List: 1,
  Gantt: 2,
  Calendar: 3,
  TaskList: 4,
  TaskBoard: 5,
  CardsList: 6,
  MapList: 7,
});
